import React from "react";
import { useDispatch, useSelector } from "react-redux";
import DragTool from "../../components/drag-tool";
import { AiOutlineUnorderedList } from "react-icons/ai";
import { setActiveCoordinate } from "../../redux/slices/activeCoordinateReducer";
import { updateCoordinatePosition, updateCoordinateSize } from "../../utils/updateCoordinates";
import { setPicklistCoordinates } from "../../redux/slices/picklistCoordinatesReducer";

const PicklistCoordinatesContainer = ({ scrollContainer }) => {
  const dispatch = useDispatch();
  const supportedFields = useSelector((state) => state.supportedFields.supportedFields);
  const activePageNumber = useSelector((state) => state.activePageNumber.activePageNumber);
  const activeCoordinate = useSelector((state) => state.activeCoordinate.activeCoordinate);
  const signatoryList = useSelector((state) => state.signatoryList.signatoryList);
  const picklistCoordinates = useSelector((state) => state.picklistCoordinates.picklistCoordinates);
  const signatureCoordinates = useSelector((state) => state.signatureCoordinates.signatureCoordinates);
  const textBoxCoordinates = useSelector((state) => state.textBoxCoordinates.textBoxCoordinates);
  const dateCoordinates = useSelector((state) => state.dateCoordinates.dateCoordinates);
  const checkBoxCoordinates = useSelector((state) => state.checkBoxCoordinates.checkBoxCoordinates);
  const emailBoxCoordinates = useSelector((state) => state.emailBoxCoordinatesReducer?.emailBoxCoordinates || []);
  const pageDimensions = useSelector((state) => state.generalDocument?.pageDimensions);

  const allCoordinates = React.useMemo(
    () => [...signatureCoordinates.map(c => ({ ...c, _isSignature: true })), ...textBoxCoordinates, ...dateCoordinates, ...checkBoxCoordinates, ...emailBoxCoordinates, ...picklistCoordinates],
    [signatureCoordinates, textBoxCoordinates, dateCoordinates, checkBoxCoordinates, emailBoxCoordinates, picklistCoordinates]
  );

  function handleDragStart(id) {
    const picklistCoordinate = picklistCoordinates.find((ele) => ele.eleId === id);
    if (picklistCoordinate) {
      dispatch(
        setActiveCoordinate({
          activeCoordinate: picklistCoordinate,
          isSelectionMode: true,
        })
      );
    }
  }

  function handleDragStop(id, data) {
    if (!data || typeof data.x !== "number" || typeof data.y !== "number") {
      console.error("Invalid drag data:", data);
      return;
    }
    const updatedCoords = updateCoordinatePosition(picklistCoordinates, id, data.x, data.y, pageDimensions);
    setTimeout(() => {
      dispatch(setPicklistCoordinates({ picklistCoordinates: updatedCoords }));
    }, 0);
  }

  function handleResize(id, data) {
     if (
      !data ||
      typeof data.width !== "number" ||
      typeof data.height !== "number"
    ) {
      console.error("Invalid resize data:", data);
      return;
    }
    const updatedCoords = updateCoordinateSize(picklistCoordinates, id, data.width, data.height, data.x, data.y, "PickList", pageDimensions);
    setTimeout(() => {
      dispatch(setPicklistCoordinates({ picklistCoordinates: updatedCoords }));
    }, 0);
  }

  return (
    <>
      {picklistCoordinates.map((ele) => {
        if (ele.pageId !== activePageNumber) return null;
        const toolName = "PickList";
        const bgColor = ele.bgColor;
        const signatory = signatoryList.find((s) => s.id === ele.signatory_id);
        const signatoryLabel = signatory?.label || `Signer ${(ele.user_index_id ?? 0) + 1}`;
        const field = supportedFields.find((field) => field.type === toolName);
        // Check if picklist has valid options
        const hasOptions = ele.options && ele.options.toString().split(",").filter(o => o.trim() !== "").length > 0;
        return (
          <DragTool
            key={ele.eleId}
            isEditMode={activeCoordinate?.eleId === ele.eleId}
            bounds={scrollContainer}
            bgColor={bgColor}
            toolType={toolName}
            eleId={ele.eleId}
            pageId={ele.pageId}
            x={ele.x}
            y={ele.y}
            width={ele.width}
            height={ele.height}
            minWidth={field?.minWidth}
            minHeight={field?.minHeight}
            maxWidth={field?.maxWidth}
            maxHeight={field?.maxHeight}
            handleDragStart={() => handleDragStart(ele.eleId)}
            handleDragStop={(e, d) => handleDragStop(ele.eleId, d)}
            handleResize={(data, e) => handleResize(ele.eleId, data)}
            allCoordinates={allCoordinates.filter((c) => c.pageId === ele.pageId)}
            toolIcon={<AiOutlineUnorderedList className={`${toolName.toLowerCase()}-tool-icon-position`} />}
            signatoryLabel={signatoryLabel}
            hasError={!hasOptions}
          />
        );
      })}
    </>
  );
};

export default PicklistCoordinatesContainer;
